/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';

const PendingOrders = ({ pendingOrders, cancelOrder, loadingOrderId }) => {
  const isValidArray = Array.isArray(pendingOrders) && pendingOrders.length > 0;

  const tableHeaderCellClassName = 'border-b widget-divider-border widget-header-fill px-2.5 py-2 text-[10px] font-medium uppercase tracking-[0.06em] text-textSecondary';
  const tableBodyCellClassName = 'border-b widget-divider-border px-2.5 py-2 align-middle text-xs text-textPrimary';
  const dangerButtonClassName = 'inline-flex items-center justify-center rounded-md border border-destructive/30 bg-destructive/10 px-2.5 py-1 text-[11px] font-medium text-destructive transition hover:bg-destructive/15';

  const safeParseFloat = (value, toFixedDigits) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '-';
    return num.toFixed(toFixedDigits);
  };

  return (
    <div className="rounded-xl border widget-muted-border bg-backgroundSurface/20 p-4 sm:p-5 mt-4 sm:mt-6">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h3 className="text-base sm:text-lg font-medium text-textPrimary">Pending Orders</h3>
        <div className="inline-flex items-center rounded-full border widget-muted-border bg-backgroundSurface/30 px-3 py-1 text-[11px] font-medium text-textSecondary">
          {isValidArray ? `${pendingOrders.length} orders` : '0 orders'}
        </div>
      </div>
      <div className="rounded-xl border widget-muted-border bg-backgroundSurface/20">
        <div className="overflow-x-auto -mx-4 sm:mx-0">
        <table className="w-full min-w-[500px] border-collapse rounded-xl overflow-visible text-xs sm:text-sm">
          <thead>
            <tr>
              <th className={tableHeaderCellClassName}>Ticket</th>
              <th className={tableHeaderCellClassName}>Symbol</th>
              <th className={tableHeaderCellClassName}>Type</th>
              <th className={tableHeaderCellClassName}>Volume</th>
              <th className={tableHeaderCellClassName}>Price</th>
              <th className={tableHeaderCellClassName}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isValidArray ? (
              pendingOrders.map((order, index) => (
                <tr key={order.ticket || index} className="transition hover:bg-secondary/10">
                  <td className={`${tableBodyCellClassName} text-center`}>
                    {order.ticket}
                  </td>
                  <td className={`${tableBodyCellClassName} text-center font-medium`}>
                    {order.symbol}
                  </td>
                  <td className={`${tableBodyCellClassName} text-center`}>
                    {order.order_type}
                  </td>
                  <td className={`${tableBodyCellClassName} text-center font-mono`}>
                    {safeParseFloat(order.volume, 2)}
                  </td>
                  <td className={`${tableBodyCellClassName} text-center font-mono`}>
                    {safeParseFloat(order.price_open, 5)}
                  </td>
                  <td className={`${tableBodyCellClassName} text-center`}>
                    <button
                      className={`${dangerButtonClassName} ${
                        loadingOrderId === order.order_id ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                      onClick={() => cancelOrder(order.order_id)}
                      disabled={loadingOrderId === order.order_id}
                    >
                      {loadingOrderId === order.order_id ? '...' : 'Cancel'}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="px-3 py-10 text-center text-sm text-textSecondary"
                >
                  No pending orders to show.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default PendingOrders;
